import { LayerData } from 'data/FlyerData';
import RootState from 'state/RootState';
import { Command, CommandFunction } from './Command';
import * as Actions from 'state/actions';
import Layer from 'data/Layer';

export class RemoveLayerCommand extends Command {
  layerId: string;
  index: number;
  layerData: LayerData;
  constructor(layerId: string) {
    super();
    this.layerId = layerId;
  }
  execute(): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      const { layers } = getState().flyer;
      for (let i = 0; i < layers.length; i++) {
        const layer = layers[i];
        if (layer.id === this.layerId) {
          this.index = i;
          this.layerData = layer.toObject();
          dispatch(Actions.removeLayer(layer));
          return;
        }
      }
    };
  }
  undo(): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const { resolution, previewPixelRatio } = flyer;
      const pixelRatio = previewPixelRatio.value;
      const layer = new Layer();
      layer.populateFromObj({
        ...this.layerData,
        stageWidth: resolution.width * pixelRatio,
        stageHeight: resolution.height * pixelRatio,
        pixelRatio
      });
      await layer.load();
      dispatch(Actions.restoreLayer(layer, this.index));
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/RemoveLayerCommand.ts